'use client'

import Link from 'next/link'
import Image from 'next/image'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-xl text-center flex flex-col items-center gap-6">

        {/* 🐝 IMAGEN (pon aquí la tuya) */}
        <div className="w-full max-w-md">
          <Image
            src="/images/errors/404-bee.png" // ← cambia esta ruta
            alt="Esta ruta no lleva a la miel"
            width={800}
            height={600}
            priority
          />
        </div>

        {/* TEXTO */}
        <h1 className="text-3xl md:text-4xl font-semibold">
          Ups… esta ruta no lleva a miel 🍯
        </h1>

        <p className="text-gray-300 text-lg leading-relaxed">
          Parece que esta página decidió irse a explorar por su cuenta.  
          No pasa nada, seguimos teniendo muchas flores cerca.
        </p>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-4">
          <Link
            href="/"
            className="rounded-xl bg-yellow-400 text-black px-6 py-3 font-medium hover:bg-yellow-300 transition"
          >
            Volver al inicio
          </Link>

          <Link
            href="/community"
            className="rounded-xl border border-white/20 px-6 py-3 hover:bg-white/10 transition"
          >
            Explorar contenido
          </Link>
        </div>

      </div>
    </div>
  )
}
